import { useState } from "react";
import { getApiUrl } from "../utils/api";
import Modal from "../components/Modal";
import LoadingSpinner from "../components/LoadingSpinner";
import ContentPage from "../components/ContentPage";

const Feedback = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [modal, setModal] = useState({
    open: false,
    title: "",
    message: "",
    type: "info",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(getApiUrl("/api/feedback"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ subject, message, email }),
      });

      const data = await res.json();
      setLoading(false);

      if (res.ok) {
        setModal({
          open: true,
          title: "Feedback Submitted",
          message:
            "Thank you for your feedback! We appreciate you helping us improve.",
          type: "success",
        });
        setSubject("");
        setMessage("");
        setEmail("");
      } else {
        setModal({
          open: true,
          title: "Submission Error",
          message: data.msg || "An error occurred. Please try again.",
          type: "error",
        });
      }
    } catch {
      setLoading(false);
      setModal({
        open: true,
        title: "Network Error",
        message:
          "Could not connect to the server. Please check your connection.",
        type: "error",
      });
    }
  };

  return (
    <ContentPage title="Contact & Feedback" narrow>
      {loading && <LoadingSpinner />}
      <Modal
        open={modal.open}
        title={modal.title}
        message={modal.message}
        type={modal.type}
        onClose={() => setModal({ ...modal, open: false })}
      />
      <h1 className="content-page__title">Contact & Feedback</h1>
      <p className="content-page__subtitle">
        Questions, ideas, or support requests—we&apos;d love to hear from you.
      </p>
      <div className="w-full space-y-6 peer-home-page-card p-5 sm:p-8 md:p-10 min-w-0 box-border">
        <div>
          <p className="text-sm text-[#777777] leading-relaxed">
            Reach us at{" "}
            <a
              href="mailto:support@peerpoetry.com"
              className="peer-home-link hover:underline"
            >
              support@peerpoetry.com
            </a>{" "}
            or send a note with the form below.
          </p>
        </div>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <input
            id="email-address"
            name="email"
            type="email"
            autoComplete="email"
            required
            className="peer-home-input block w-full px-4 py-2.5 sm:text-sm"
            placeholder="Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            id="subject"
            name="subject"
            type="text"
            required
            className="peer-home-input block w-full px-4 py-2.5 sm:text-sm"
            placeholder="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <textarea
            id="message"
            name="message"
            rows="4"
            required
            className="peer-home-input block w-full px-4 py-2.5 sm:text-sm resize-y"
            placeholder="Your message, feedback, or question..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button type="submit" className="w-full peer-home-btn-primary py-2.5">
            Submit Feedback
          </button>
        </form>
      </div>
    </ContentPage>
  );
};

export default Feedback;
